import { Component, EventEmitter, inject, OnInit, Output, computed, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { SIDE_NAV_ITEMS } from '../../../models/side-nav-items';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header implements OnInit {

  @Output() toggleSidebar = new EventEmitter<boolean>();

  private router = inject(Router);

  private currentRoute = signal('');
  isDark = signal(false);

  breadcrumbs = computed(() => {
    const url = this.currentRoute();
    const matched = SIDE_NAV_ITEMS.find(item => item.routePath && url.startsWith(item.routePath));
    if (matched) {
      return [
        { label: matched.group ?? 'Console' },
        { label: matched.label },
      ];
    }
    return url.split('/').filter(Boolean).map(seg => ({
      label: seg.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    }));
  });

  ngOnInit(): void {
    const saved = localStorage.getItem('theme-mode');
    if (saved === 'dark') {
      document.documentElement.setAttribute('data-mode', 'dark');
      this.isDark.set(true);
    }
    this.currentRoute.set(this.router.url);
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.currentRoute.set(this.router.url));
  }

  toggleMode(): void {
    const next = this.isDark() ? 'light' : 'dark';
    document.documentElement.setAttribute('data-mode', next);
    localStorage.setItem('theme-mode', next);
    this.isDark.set(!this.isDark());
  }

  toggleSideNav(): void {
    this.toggleSidebar.emit();
  }
}
